import { ref } from 'vue';
// import wx from 'weixin-js-sdk';
import { getApi } from '../../init';
import { loadScript } from '../../utils/loadScript';

export function useMobilePay() {
  const { aiadOrderApi, tcWechatApi, tcAlipayApi } = getApi();

  const loading = ref(false);
  const payInfo = ref();
  const orderInfo = ref();

  async function createOrder(orderChannel: string, payCode: string) {
    // orderInfo.value = await aiadOrderApi.createOrder({
    //   code: payCode,
    //   orderChannel,
    // });

    orderInfo.value = await aiadOrderApi.createOrder({
      code: orderChannel === 'alipay' ? decodeURIComponent(payCode) : payCode,
      orderChannel: orderChannel,
    });
  }

  async function initWx(options: {
    orderChannel: string;
    payCode: string;
    wxConfig: { appid: string; openid: string; payRedirectUri: string };
  }) {
    const { orderChannel, payCode, wxConfig } = options;
    const { openid } = wxConfig;
    loading.value = true;

    await createOrder(orderChannel, payCode);
    payInfo.value = await tcWechatApi.createOrder({
      openId: openid,
      tradeNo: orderInfo.value.tradeNo,
    });
    loading.value = false;
  }

  async function handleWxPay(wxConfig: { appid: string; openid: string; payRedirectUri: string }) {
    if (!payInfo.value) return;
    const { WeixinJSBridge } = window as any;
    await new Promise<void>((resolve) => {
      function onBridgeReady() {
        resolve();
      }

      if (typeof WeixinJSBridge == 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
        }
        // @ts-ignore
        else if (document.attachEvent) {
          // @ts-ignore
          document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
          // @ts-ignore
          document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
        }
      } else {
        onBridgeReady();
      }
    });

    await new Promise<void>((resolve, reject) => {
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          appId: payInfo.value.appId, //公众号ID，由商户传入
          timeStamp: payInfo.value.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: payInfo.value.nonceStr, //随机串
          package: payInfo.value.packageVal,
          signType: payInfo.value.signType, //微信签名方式：
          paySign: payInfo.value.paySign, //微信签名
        },
        function (res: any) {
          if (res.err_msg == 'get_brand_wcpay_request:ok') {
            // WeixinJSBridge.call('closeWindow');
            // window.close();
            if (wxConfig.payRedirectUri) {
              location.href = wxConfig.payRedirectUri;
            }

            resolve();
          } else {
            reject();
          }
        },
      );
    });
  }

  let cmbPayInfo;
  async function initZfb(options: {
    orderChannel: string;
    payCode: string;
    zfbConfig: {
      payRedirectUri: string;
    };
  }) {
    const { orderChannel, payCode } = options;
    function getEnv() {
      // ip或者localhost
      if (
        /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/.test(location.host) ||
        location.host.includes('localhost')
      ) {
        return 'localhost';
      } else if (location.host.includes('dev')) {
        return 'dev';
      } else if (location.host.includes('fat')) {
        return 'fat';
      }
      return 'prod';
    }
    const env = (() => {
      const obj: any = {
        localhost: {
          aliAppid: '2021005132655658',
        },
        dev: {
          aliAppid: '2021005132655658',
        },
        fat: {
          aliAppid: '2021005132655658',
        },
        prod: {
          aliAppid: '2021004123627444',
        },
      };
      return obj[getEnv()];
    })();

    await loadScript(
      'https://gw.alipayobjects.com/as/g/h5-lib/alipayjsapi/3.1.1/alipayjsapi.min.js',
    );

    const authCode = await new Promise<string>((resolve) => {
      // @ts-ignore
      window.ap.getAuthCode(
        {
          appId: env.aliAppid,
          scopes: ['auth_user'],
        },
        function (res: any) {
          resolve(res.authCode);
        },
      );
    });

    if (!authCode) {
      // @ts-ignore
      window.AlipayJSBridge.call('popWindow');
      window.close();
      return;
    }

    const [result] = await Promise.all([
      tcAlipayApi.getAliUserInfo({ code: authCode }),
      await createOrder(orderChannel, payCode),
    ]);

    cmbPayInfo = await tcAlipayApi.createOrderByCMB({
      tradeNo: orderInfo.value.tradeNo,
      buyerId: result.userId,
    });

    await new Promise<void>((resolve) => {
      // @ts-ignore
      if (window?.AlipayJSBridge) {
        resolve && resolve();
      } else {
        // 如果没有注入则监听注入的事件
        document.addEventListener('AlipayJSBridgeReady', () => resolve(), false);
      }
    });
  }

  async function handleZfbPay(zfbConfig: { payRedirectUri: string }) {
    await new Promise<void>((resolve) => {
      // @ts-ignore
      window.AlipayJSBridge.call(
        'tradePay',
        {
          tradeNO: cmbPayInfo,
        },
        (result: any) => {
          if (result.resultCode === '9000') {
            if (zfbConfig.payRedirectUri) {
              location.href = zfbConfig.payRedirectUri;
            }
            resolve();
            // // @ts-ignore
            // window.AlipayJSBridge.call('popWindow');
            // window.close();
          }
        },
      );
    });
  }

  function getOrderEnv() {
    if (/MicroMessenger/.test(window.navigator.userAgent)) {
      return 'wechat';
    } else if (/AlipayClient/.test(window.navigator.userAgent)) {
      return 'alipay';
    } else {
      return '';
    }
  }

  async function pay({ payCode, wxConfig, zfbConfig }) {
    // 判断当前支付环境
    const orderEnv = getOrderEnv();

    // 支付方式为支付宝
    if (orderEnv === 'alipay') {
      await initZfb({ orderChannel: orderEnv, payCode, zfbConfig });
      await handleZfbPay(zfbConfig);
    }

    // 支付方式为微信
    else if (orderEnv === 'wechat') {
      await initWx({ orderChannel: orderEnv, payCode, wxConfig });
      await handleWxPay(wxConfig);

      // // 非微信环境下使用deeplink
      // await initWxH5({ orderChannel, payCode });
      // await handleWxH5Pay({ orderChannel, payCode, wxConfig });
    } else {
      return {
        success: false,
        message: '当前环境不支持该支付方式',
      };
    }

    return {
      success: true,
      message: null,
    };
  }

  return {
    pay,
    getOrderEnv,
  };
}
